import type { ButtonVariant } from '@heidi/design-system/button';
import type { IconProps } from '@heidi/design-system/icons';
import { TierPracticeFilled, TierProFilled } from '@heidi/design-system/icons';
import type { ForwardRefExoticComponent, RefAttributes } from 'react';

import { CLINICIAN_MAX_UPGRADE_BUTTON_CLASS } from '../clinician-max-upgrade-theme';
import type { UpgradeCtaTier } from './types';

type UpgradeCtaButtonPreset = {
  variant: ButtonVariant;
  Icon: ForwardRefExoticComponent<IconProps & RefAttributes<SVGSVGElement>>;
  buttonClassName?: string;
};

export const UPGRADE_CTA_BUTTON_PRESETS = {
  clinicianMax: {
    variant: 'secondary',
    Icon: TierProFilled,
    buttonClassName: CLINICIAN_MAX_UPGRADE_BUTTON_CLASS,
  },
  practiceMax: {
    variant: 'pro_plus',
    Icon: TierPracticeFilled,
  },
} as const satisfies Record<UpgradeCtaTier, UpgradeCtaButtonPreset>;

export function getUpgradeCtaButtonPreset(tier: UpgradeCtaTier): UpgradeCtaButtonPreset {
  return UPGRADE_CTA_BUTTON_PRESETS[tier];
}
